import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorCategories } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const CALEQUITYINDEX_LAYER_ID = 'calEquityIndexLayer';
export const CATEGORY_COLORS = {
  'Transportation-Based Priority Populations': [129, 15, 124],
  'Traffic Exposure': [136, 86, 167],
  'Access to Destinations': [140, 150, 198],
  'Demographic Overlay': [179, 205, 227],
  'Non-Screened Blocks': [237, 248, 251],
};

const DATA = Object.entries(CATEGORY_COLORS).map((elem) => {
  return { color: elem[1], label: elem[0] };
});

const layerConfig = {
  title: 'Equity Index',
};

function CalEquityIndexLayer() {
  const dispatch = useDispatch();
  const { calEquityIndexLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, calEquityIndexLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (calEquityIndexLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: CALEQUITYINDEX_LAYER_ID,

      stroked: false,
      filled: true,
      getFillColor: colorCategories({
              attr: 'SCREEN',
              domain: Object.keys(CATEGORY_COLORS),
              colors: Object.values(CATEGORY_COLORS),
            }),

      pointRadiusMinPixels: 3.5,

      pickable: true,
      visible: calEquityIndexLayer.visible,
      opacity: calEquityIndexLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: CALEQUITYINDEX_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Equity Index Details',
              includeColumns: [
                'COUNTYFP20',
                'UR20',
                'SCREEN',
                'TRIBAL_LAND_INDICATOR',
                'LOW_INCOME_INDICATOR',
                'TBPP_SCREEN',
                'TRAFFIC_EXPOSURE_SCREEN',
                'median_hh_income',
                'rounded_hh_size',
                'local_low_income_threshold',
                'traffic_proximity_and_volume_pe',
                'crash_percentile_local',
                'PED_RATIO',
                'BIKE_RATIO',
                'TRANSIT_RATIO_JOBS',
                'TRANSIT_RATIO_POIs',
                'weighted_aadt_score',
              ],
            }),
          };
        }
      },
    });
  }
}

export default CalEquityIndexLayer;
